module.exports = __webpack_public_path__ + "img/doge.88575a28.png";